import React, { useState, useEffect } from 'react';
// import BreadCrumb from '../../../../Components/Utils/Breadcrumbs';
import { BackButton, EditButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation, useParams } from 'react-router-dom';
import Dashboard from '../../../../Components/Icons/Dasboard';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { NormalHeading } from '../../../../Components/Utils/Heading';
import axiosInstance from '../../../../Services/axiosCommon';

const ViewAgents = () => {
  const { agentsViewId } = useParams();
  const location = useLocation();
  const locationData = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;

  const [data, setData] = useState(locationData || null);

  useEffect(() => {
    if (!locationData && agentsViewId) {
      axiosInstance
        .get(`/agents/${agentsViewId}`)
        .then((res) => {
          setData(res.data?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [agentsViewId, locationData]);

  if (!data) {
    return (
      <div className="w-full h-[calc(100vh-145px)] flex items-center justify-center bg-white rounded-lg shadow-lg">
        <div className="flex flex-col items-center gap-2">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#048178]"></div>
          <p className="text-sm font-medium text-gray-500">Loading agent details...</p>
        </div>
      </div>
    );
  }

  const servicesList = data?.services
    ? (Array.isArray(data.services)
      ? data.services
      : data.services.split(",").map((s) => s.trim()).filter(Boolean))
    : [];

  return (
    <div className="w-full h-full p-2 lg:px-4">
      <div className="w-full flex flex-row justify-between items-center gap-2 mb-3">
        <Breadcrumb
          items={
            [
              {
                name: "Shipping",
                link: "/shipping/agents"
              },
              {
                name: "Shipping Agent",
                link: "/shipping/agents"
              },
              {
                name: "View Agents"
              }]
          }
        />
        <div className="flex items-center gap-2 flex-shrink-0">
          <Link to={'/shipping/agents'} state={{ currentPage: pageIndex, searchQuery: searchQuery != "" ? searchQuery : "" }}><BackButton link={true} /></Link>
          <Link to={`/shipping/agents/edit/${data?.agentId}`} state={{ data: data, from: `/shipping/agents/view/${data?.agentId}`, pageIndex, searchQuery }}><EditButton height='8' /></Link>
        </div>
      </div>
      <div className="w-full mx-auto min-h-[calc(100vh-145px)] h-auto bg-white rounded-md overflow-y-auto p-2 sm:p-4 mt-4">
        <NormalHeading title={data?.companyName || '-'} />
        <div className='flex flex-col md:flex-row gap-4 mt-2'>
          <div className='w-full md:w-1/2 flex'>
            <div className='w-full rounded-[20px] bg-white py-2 flex flex-col'>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Agent Type</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.type || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Phone</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.phone?.display || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Email</p>
                <p className='w-1/2 py-2  pl-3 sm:pl-5 text-xs text-[#606279] break-words'>{data?.email || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Website</p>
                <p className='w-1/2 py-2 truncate pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.website || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Ratings</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.ratings || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Contact Person </p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.cpName || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Contact Person Email</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279] break-words'>{data?.cpEmail || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Contact Person Phone</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.cpPhone?.display || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Contact Person Designation</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.cpDesignation || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Vat Number</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.vatNum || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>CR Number</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.crNum || '-'}</p>
              </div>
            </div>
          </div>
          <div className='hidden md:block border-r border-[1px] border-slate-200/60 border-solid' />

          <div className='w-full md:w-1/2 flex'>
            <div className='w-full rounded-[20px] bg-white py-2 flex flex-col'>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Country</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.country || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>State</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.state || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>City</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.city || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Street</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.streetName || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Postal Code</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.postalCode || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Shipping Address</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.shippingAddress || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Billing Address</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.billingAddress || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Status</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.status || '-'}</p>
              </div>
              <div className='odd:bg-white even:bg-slate-50 w-full flex px-2'>
                <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Comments</p>
                <p className='w-1/2 py-2 pl-3 sm:pl-5 text-xs text-[#606279]'>{data?.comments || '-'}</p>
              </div>
            </div>
          </div>
        </div>

        <p className="w-full pb-2 pt-4 px-2 text-sm font-medium text-[#111537]">
          Services
        </p>
        <div className="border-t border-[1px] border-slate-200/60 border-solid w-full mb-3"></div>

        <div className="w-full flex flex-wrap gap-2 px-2">
          {servicesList.length > 0 ? (
            servicesList.map((service, index) => (
              <span
                key={index}
                className="px-3 py-1.5 text-xs font-medium bg-[#B3EBD7] text-[#111537] rounded-md border border-[#048178]/20"
              >
                {service}
              </span>
            ))
          ) : (
            <p className="text-xs text-[#606279]">-</p>
          )}
        </div>
      </div>
    </div>
  )
};
export default ViewAgents;

